<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height: 54px; line-height: 54px">
        <img style="vertical-align: middle" src="@/assets/beadhouse/juxing.png" />
        <span>智能看护</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for="(item, index) in infoList" :key="index" @click="handleClick(item)">
        <a>
          <img :src="item.img" />
          <h5 style="font-size: 16px">{{ item.title }}</h5>
          <span style="font-size: 13px">{{ item.text }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "Intelligent",
  data() {
    return {
      infoList: [], //数据源
    };
  },
  methods: {
    handleClick(item) {
      bus.$emit("homePage", {
        type: "jump",
        path: item.url,
        title: item.title
      });

    },
    /**
     * 获取菜单栏的数据列表
     */
    getPageData() {
      this.infoList = [
        {
          uid: 1,
          title: "智能魔盒",
          text: "带网关功能的视频伴侣",
          img: require("@/assets/beadhouse/xungengbang.png"),
          url: "/MagicBox"
        },
        {
          uid: 2,
          text: "带通话功能的语音网关",
          title: "智能网关",
          img: require("@/assets/beadhouse/gateway.png"),
          url: "/CallGateWayDeviceList"
        },
        {
          uid: 221,
          text: "亲情呼叫电话",
          title: "亲情通",
          img: require("@/assets/beadhouse/watchcarelist.png"),
          url: "/CallPhoneDeviceList"
        },
        {
          uid: 3,
          title: "智能门禁卡",
          text: "门禁卡管理",
          img: require("@/assets/beadhouse/accesslist.png"),
          url: "/accesslist"
        },
        {
          uid: 4,
          title: "智能门禁",
          text: "门禁管理",
          img: require("@/assets/beadhouse/cardlist.png"),
          url: "/cardlist"
        },
        {
          uid: 5,
          title: "门禁记录",
          text: "对老人外出记录进行管理",
          img: require("@/assets/beadhouse/GuardGroupInfo.png"),
          url: "/DoorAllRecord"
        },
        {
          uid: 6,
          title: "智能床垫",
          text: "智能睡眠监测仪",
          img: require("@/assets/beadhouse/chuangdianlist.png"),
          url: "/SleepMattresslist"
        },
        {
          uid: 7,
          title: "多功能检测仪",
          text: "可以测量体温、血压、血氧、心电数据",
          img: require("@/assets/beadhouse/followlist.png"),
          url: "/followlist"
        },
        {
          uid: 8,
          title: "孝心环",
          text: "孝心手环可以对老人进行定位监测",
          img: require("@/assets/beadhouse/watchlist.png"),
          url: "/Watchlist"
        },
        {
          uid: 9,
          title: "护工手表",
          text: "对所有的设备报警信息进行推送处理",
          img: require("@/assets/beadhouse/watchcarelist.png"),
          url: "/NursingWatch"
        },
        {
          uid: 10,
          text: "体征雷达",
          title: "体征监测雷达",
          img: require("@/assets/beadhouse/bodyinduction.png"),
          url: "/healthRadarList"
        },
        {
          uid: 11,
          text: "跌倒雷达",
          title: "跌倒监测雷达",
          img: require("@/assets/beadhouse/newBodyinduction.png"),
          url: "/FallRadarList"
        },
        {
          uid: 12,
          text: "清雷雷达",
          title: "清雷体征雷达",
          img: require("@/assets/beadhouse/bodyinduction.png"),
          url: "/QLRadarlist"
        },
        {
          uid: 13,
          text: "清雷跌倒雷达",
          title: "清雷跌倒雷达",
          img: require("@/assets/beadhouse/newBodyinduction.png"),
          url: "/QLFallRadarlist"
        },
        {
          uid: 14,
          title: "床头屏",
          text: "展示房间内的老人情况",
          img: require("@/assets/beadhouse/accessEvent.png"),
          url: "/BedsideScreenList"
        },
       
        {
          uid: 15,
          title: "萤石海康摄像头",
          text: "萤石海康摄像头管理及查看",
          img: require("@/assets/beadhouse/camera.png"),
          url: "/Camera"
        },
        {
          uid: 24,
          title: "智能手环",
          text: "能测量心率、血氧、体温等功能的4G智能手环",
          img: require("@/assets/beadhouse/watchlist.png"),
          url: "/bracelet"
        },
        {
          uid: 25,
          title: "4G血压计",
          text: "4G智能血压计能够实时上传测量结果",
          img: require("@/assets/beadhouse/hulixiangmu.png"),
          url: "/BloodPressList"
        },
        {
          uid: 26,
          title: "4G血糖仪",
          text: "4G智能血糖仪能够实时上传测量结果",
          img: require("@/assets/beadhouse/huli.png"),
          url: "/BloodSugarList"
        },
        {
          uid: 27,
          title: "跌倒摄像头",
          text: "火柴人跌倒摄像头",
          img: require("@/assets/beadhouse/camera.png"),
          url: "/AotongCamera"
        },
        {
          uid: 26,
          title: "体检一体机",
          text: "体检一体机",
          img: require("@/assets/beadhouse/xungengshezhi.png"),
          url: "/physicalList"
        },
        {
          uid: 29,
          title: "巡更棒",
          text: "对所有的房间床位进行巡更",
          img: require("@/assets/beadhouse/xungengbang.png"),
          url: "/patrollingRod"
        },
        {
          uid: 30,
          title: "巡更点",
          text: "绑定巡更棒并打卡",
          img: require("@/assets/beadhouse/xungengdian.png"),
          url: "/PatrolPoints"
        },
        {
          uid: 31,
          title: "巡更记录",
          text: "巡更人巡更的时间地点等",
          img: require("@/assets/beadhouse/xungengjilu.png"),
          url: "/PatrollingRecord"
        },
        {
          uid: 35,
          title: "萤石云应用信息",
          text: "管理萤石摄像头应用信息",
          img: require("@/assets/beadhouse/yingshiInfo.png"),
          url: "/cameraAppInfo"
        },
        {
          uid: 37,
          title: "燃气报警器",
          text: "燃气报警器",
          img: require("@/assets/beadhouse/xungengdian.png"),
          url: "/FuelAlertor"
        },
        {
          uid: 38,
          title: "门磁感应器",
          text: "门磁感应器",
          img: require("@/assets/beadhouse/menjinkaquanxian.png"),
          url: "/MagneticLnductor"
        },
        {
          uid: 39,
          title: "红外感应器",
          text: "红外感应器",
          img: require("@/assets/beadhouse/newBodyinduction.png"),
          url: "/LnfraredLnductor"
        },
        {
          uid: 40,
          title: "紧急呼叫器",
          text: "紧急呼叫器",
          img: require("@/assets/beadhouse/buttonlist.png"),
          url: "/UrgencyBeeper"
        },
        {
          uid: 41,
          title: "烟雾报警器",
          text: "烟雾报警器",
          img: require("@/assets/beadhouse/AlertLight.png"),
          url: "/SmogAlertor"
        },
        {
          uid: 42,
          title: "溢水报警器",
          text: "溢水报警器",
          img: require("@/assets/beadhouse/hulijibieguanli.png"),
          url: "/overflowAlertor"
        },
        {
          uid: 46,
          title: "小度音箱",
          text: "小度音箱",
          img: require("@/assets/beadhouse/hulixiangmu.png"),
          url: "/XiaoduSound"
        },
        {
          uid: 43,
          title: "智能电表",
          text: "物联网智能电表,实时采集",
          img: require("@/assets/beadhouse/jiaobanrizhi2.png"),
          url: "/eMeterList"
        },
        {
          uid: 44,
          title: "智能水表",
          text: "物联网智能水表,实时采集",
          img: require("@/assets/beadhouse/jiaobanrizhi2.png"),
          url: "/wMeterList"
        },
        {
          uid: 45,
          title: "移动WIFI",
          text: "给未开通网络的家庭提供网络",
          img: require("@/assets/beadhouse/ServiceCategory.png"),
          url: "/wifiDeviceList"
        }
      ]
    },
  },
  created() {
    this.getPageData();
  },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.public_bg {
  width: 100%;
  height: auto;
  overflow-y: scroll;
  overflow: hidden;
  padding: 0 0 20px 0;
  background: #fefefe;

  .nurse_top {
    border: 1px #f1eff2 solid;
    background: #f9f7fa;
    position: relative;

    img {
      margin: 14px 12px;
    }

    h5 {
      display: inline-block;
      position: absolute;
      top: 12px;
      font-size: 18px;
    }
  }

  .row_link {
    width: 98%;
    margin: 10px 15px;

    .item {
      width: 230px;
      height: 99px;
      border: #f0f0f2 1px solid;
      margin-bottom: 24px;
      margin-right: 24px;
      float: left;
      cursor: pointer;

      img {
        float: left;
        margin: 8px 12px 8px 15px;
        margin-right: 15px;
        max-width: 80px;
      }

      span {
        color: #666666;
      }

      h5 {
        margin-top: 21px;
        margin-bottom: 8px;
      }

      a:hover {
        color: #333;
      }
    }

    .item:hover {
      border: 1px solid red;
    }
  }
}
</style>
